<template>
  <div id="app" style="margin: 0">
    <navbar v-if="showNavbar"></navbar>
    <router-view></router-view>
  </div>
</template>
<script>
import navbar from "./components/Navbar";
import { getAuth, onAuthStateChanged } from "firebase/auth";
export default {
  components: {
    navbar,
  },
  data() {
    return {
      showNavbar: null,
    }
  },
  watch: {
    '$route'(routeObject) {
      this.getCurrentPage(routeObject)
    }
  },
  methods: {
    getCurrentPage(routeObject) {
      if (routeObject.name === 'preview') {
        this.showNavbar = false;
      } else {
        this.showNavbar = true;
      }
    }
  },
  componentDidMount() {
    onAuthStateChanged(
      getAuth(),
      function (user) {
        if (!user) {
          this.$router.replace({
            name: "notallowed",
          });
          return;
        } else {
          this.$router.replace({
            name: "posts",
          });
        }
      }.bind(this)
    );
  },
};
</script>

<style scoped>
#app {
  width: 100vw !important;
  height: 100vh !important;
}
</style>